document.addEventListener('click', function (e) {
  if (e.target.closest('.upsell1-prev-btn')) {
    const carousel = e.target.closest('.upsell1-carousel-container').querySelector('[data-custom-carousel1]');
    if (carousel) carousel.scrollBy({ left: -150, behavior: 'smooth' });
  }
  if (e.target.closest('.upsell1-next-btn')) {
    const carousel = e.target.closest('.upsell1-carousel-container').querySelector('[data-custom-carousel1]');
    if (carousel) carousel.scrollBy({ left: 150, behavior: 'smooth' });
  }
  if (e.target.closest('.upsell2-prev-btn')) {
    const carousel = e.target.closest('.upsell2-carousel-container').querySelector('[data-custom-carousel2]');
    if (carousel) { carousel.scrollBy({ left: -carousel.offsetWidth, behavior: 'smooth' });}
  }
  if (e.target.closest('.upsell2-next-btn')) {
    const carousel = e.target.closest('.upsell2-carousel-container').querySelector('[data-custom-carousel2]');
    if (carousel) { carousel.scrollBy({ left: carousel.offsetWidth, behavior: 'smooth' }); }
  }
});

// Function to bind drag/touch scroll for all carousels
function bindCarouselDrag() {
  document.querySelectorAll('[data-custom-carousel1]').forEach(carousel => {
    // Avoid double-binding
    if (carousel.dataset.dragBound) return;
    carousel.dataset.dragBound = "true";

    let isDown = false;
    let startX;
    let scrollLeft;

    // Mouse / Touch drag start
    carousel.addEventListener("mousedown", (e) => {
      isDown = true;
      carousel.classList.add("upsell1-dragging");
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener("touchstart", (e) => {
      isDown = true;
      carousel.classList.add("upsell1-dragging");
      startX = e.touches[0].pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    // Mouse / Touch drag move
    const moveHandler = (x) => {
      if (!isDown) return;
      const walk = x - startX;
      carousel.scrollLeft = scrollLeft - walk;
    };

    carousel.addEventListener("mousemove", (e) => {
      moveHandler(e.pageX - carousel.offsetLeft);
    });

    carousel.addEventListener("touchmove", (e) => {
      moveHandler(e.touches[0].pageX - carousel.offsetLeft);
    });

    // Drag end
    ["mouseup", "mouseleave", "touchend"].forEach((event) => {
      carousel.addEventListener(event, () => {
        isDown = false;
        carousel.classList.remove("upsell1-dragging");
      });
    });
  });
  document.querySelectorAll('[data-custom-carousel2]').forEach(carousel => {
    // Avoid double-binding
    if (carousel.dataset.dragBound) return;
    carousel.dataset.dragBound = "true";

    let isDown = false;
    let startX;
    let scrollLeft;

    carousel.addEventListener('mousedown', e => {
      isDown = true;
      carousel.classList.add('active-drag');
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener('mouseleave', () => {
      isDown = false;
      carousel.classList.remove('active-drag');
    });

    carousel.addEventListener('mouseup', () => {
      isDown = false;
      carousel.classList.remove('active-drag');
    });

    carousel.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 3;
      carousel.scrollLeft = scrollLeft - walk;
    });

    carousel.addEventListener('touchstart', e => {
      isDown = true;
      startX = e.touches[0].pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener('touchend', () => {
      isDown = false;
    });

    carousel.addEventListener('touchmove', e => {
      if (!isDown) return;
      const x = e.touches[0].pageX - carousel.offsetLeft;
      const walk = (x - startX) * 3;
      carousel.scrollLeft = scrollLeft - walk;
    });
  });
}

// Button clicks handled via event delegation (never break)
document.addEventListener('click', function (e) {
  if (e.target.closest('.upsell1-prev-btn')) {
    const carousel = e.target.closest('.upsell1-carousel-container').querySelector('[data-custom-carousel1]');
    if (carousel) carousel.scrollBy({ left: -150, behavior: 'smooth' });
  }
  if (e.target.closest('.upsell1-next-btn')) {
    const carousel = e.target.closest('.upsell1-carousel-container').querySelector('[data-custom-carousel1]');
    if (carousel) carousel.scrollBy({ left: 150, behavior: 'smooth' });
  }
  if (e.target.closest('.upsell2-prev-btn')) {
    const carousel = e.target.closest('.upsell2-carousel-container').querySelector('[data-custom-carousel2]');
    if (carousel) carousel.scrollBy({ left: -carousel.offsetWidth, behavior: 'smooth' });
  }
  if (e.target.closest('.upsell2-next-btn')) {
    const carousel = e.target.closest('.upsell2-carousel-container').querySelector('[data-custom-carousel2]');
    if (carousel) carousel.scrollBy({ left: carousel.offsetWidth, behavior: 'smooth' });
  }
});

function bindShippingProtectionToggle() {
  const spCheckbox = document.getElementById('shipping-protection-checkbox');
  if (spCheckbox) {
    spCheckbox.addEventListener('change', function() {
      if (this.checked) {
        addShippingProtection();
      } else {
        removeShippingProtection();
      }
    });
  }
}

async function addShippingProtection() {
  const elements = document.getElementsByClassName('sp-add-btn');
  if (elements.length > 0) {
    elements[0].click();
  }
}

async function removeShippingProtection() {
  try {
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart data.');
    }
    const cart = await cartResponse.json();
    const itemToRemove = cart.items.find(item =>
      item.handle === 'shipping-protection'
    );
    if (itemToRemove) {
      const updates = { [itemToRemove.key]: 0 };
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      await updateResponse.json();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } else {
      console.log('Shipping protection item not found in cart.');
    }
  } catch (error) {
    console.error('Error in cart operation:', error);
  }
}
document.addEventListener('DOMContentLoaded', () => {
  bindCarouselDrag();
  bindShippingProtectionToggle();
});

const cartDrawer = document.querySelector('#cart-drawer, .cart-drawer, #CartDrawer, .cart');
if (cartDrawer) {
  const observer = new MutationObserver(() => {
    bindCarouselDrag();
    bindShippingProtectionToggle();
  });
  observer.observe(cartDrawer, { childList: true, subtree: true });

  cartDrawer.addEventListener('cart-drawer:refreshed', () => {
    bindShippingProtectionToggle();
  });
}
